import { createApi } from '@reduxjs/toolkit/query/react'
import baseQueryWithReauth from '../../../common/BaseQueryWithReAuth';
import { LOGIN_POST_URL, VALIDATEOTP_POST_URL } from '../../../constants/service-constants';
import { ILoginResponse, ILoginRequest, IValidateOtpResponse, IValidateOtpRequest } from '../models/ILoginModels';


export const authApi = createApi({
  reducerPath: 'authApi',
  // baseQuery: fetchBaseQuery({
  //   baseUrl: `${SERVER_BASE_URL}`,
  //   prepareHeaders: (headers, { getState }) => {
  //     // By default, if we have a token in the store, let's use that for authenticated requests
  //     const token = (getState() as RootState).auth.accessToken;
  //     if (token) {
  //       headers.set('authorization', `Bearer ${token}`);
  //     }
  //     return headers;
  //   },
  // }),
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    login: builder.mutation<ILoginResponse, ILoginRequest>({
      query: (credentials) => ({
        url: `${LOGIN_POST_URL}`,
        method: 'POST',
        body: credentials,
      }),
    }),
    validateOtp: builder.mutation<IValidateOtpResponse, IValidateOtpRequest>({
      query: (payload) => ({
        url: `${VALIDATEOTP_POST_URL}`,
        method: 'POST',
        body: payload
      }),
      transformResponse: async (response: IValidateOtpResponse) => {
        return response;        
      },
      async onQueryStarted(_, {queryFulfilled}) {
        // onStart side-effect
        try {
          const {data} = await queryFulfilled;

          // store auth data in local storage for later
          localStorage.setItem('auth', JSON.stringify(data));
        } catch (err) {
          console.error('There was an error validating OTP', err);
        }
      }
    }),

  }),
})

export const { useLoginMutation, useValidateOtpMutation } = authApi
